import React from 'react'
import { useNavigate } from "react-router-dom"

export default({url}) => {
  const navigate = useNavigate()

  return (
    <div className="cursor-pointer text-xs md:text-sm font-extralight uppercase " onClick={() => { navigate(url ? url : -1) }}>
      <span className="ml-1 material-symbols-rounded text-sm">
         arrow_back_ios
      </span> 
      Back
    </div>
  )
}